import React, { useState } from "react";

import {
  Box,
  Typography,
  Divider,
  Paper,
  Container,
  IconButton,
  Tooltip,
  Tabs,
  Tab,
  Button,
} from "@mui/material";
import { AllSideTabs } from "../../constants";
import { TabConfig } from "../../types/GeneralTypes";
import { ResetGameLogs } from "./Data/GameLogs/resetGameLogs";

export const Admin = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [showResetGameLog, setShowResetGameLog] = useState(false);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  const handleResetGameLog = () => {
    setShowResetGameLog(true);
  };

  return (
    <Box sx={{ flex: 1, p: 1 }}>
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          "& .MuiTabs-indicator": {
            backgroundColor: "rgba(123, 45, 58, 0.9)",
          },
          "& .MuiTab-root": {
            color: "rgba(255, 255, 255, 0.7)",
            "&.Mui-selected": {
              color: "white",
            },
          },
        }}
      >
        <Tab key={0} label={"Data"} id={`admin-tab-0`} />
        <Tab key={1} label={"Users"} id={`admin-tab-1`} />
      </Tabs>
      <Divider />

      {/* Data Tab */}
      {selectedTab === 0 && (
        <Box sx={{ p: 1 }}>
          {/* header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography>Data Management</Typography>
          </Box>
          <Divider />
          {/* Content */}
          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleResetGameLog}
            >
              Reset Game Log
            </Button>
          </Box>
        </Box>
      )}

      {/* Users Tab */}
      {selectedTab === 1 && (
        <Box sx={{ p: 1 }}>
          <Typography>Users</Typography>
        </Box>
      )}

      <ResetGameLogs showResetGameLog={showResetGameLog} handleClose={() => setShowResetGameLog(false)} />
    </Box>
  );
};
